<script setup>
import { computed, onMounted } from 'vue';

// Props 정의
const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },

    htmlTemplate: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    visible: {
        type: Boolean,
        default: true
    },
    dataList: {
        type: [Array, Object],
        default: () => []
    }
});

const dataList = computed(() => props.dataList);
console.log(dataList.value);
const emit = defineEmits(['update:modelValue', 'input', 'enter', 'item-select', 'update-options']);
const onItemSelect = () => {
    alert('test');
    emit('input', { id: '123456', value: '2' });
};

onMounted(() => {
    document.querySelector('.html-content')?.addEventListener('click', (e) => {
        if (e.target.matches('.dynamic-btn[data-action="test"]')) {
            onItemSelect(); // Vue 메서드 호출
        }
    });
});

const compiledTemplate = computed(() => {
    let template = props.htmlTemplate;
    for (const [key, value] of Object.entries(dataList.value)) {
        const placeholder = `{{${key}}}`;
        const regex = new RegExp(placeholder, 'g');
        template = template.replace(regex, value);
    }

    let buttonTest = `{{buttonTestClick}}`;
    let regexBtn = new RegExp(buttonTest, 'g');
    if (regexBtn) {
        template = template.replace(regexBtn, `<button class="dynamic-btn" data-action="test">이동하기</button>`);
    }
    return template;
});
</script>

<template>
    <div
        v-if="visible"
        class="flex items-center"
        :style="{
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight
        }"
    >
        <div class="relative html-content">
            <div v-html="compiledTemplate"></div>
        </div>
    </div>
</template>

<style scoped>
.label-text {
    font-family: 'SCoreDream500';
    font-size: 0.95rem;
    color: #374151;
    width: 100%;
}

.label-required {
    color: #f87171; /* red-500 */
}

.label-required::after {
    content: '*';
    color: #f87171;
    margin-left: 0.25rem;
    margin-right: 0.2rem;
}

input:focus {
    border-color: #0038ea;
    outline: none;
}

.html-content {
    width: 100%;
    font-family: 'SCoreDream400';
    /* height: 1.5rem; */
    padding-top: 0.18rem;
    font-size: 0.9rem;
    color: #111827;
}
legend {
    font-size: 1rem;
    font-family: 'SCoreDream500';
    flex-shrink: 0;
    padding: 1.3rem 0 0 0;
}
.note-grid {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
}

.note-grid th,
.note-grid td {
    border: 0.1rem solid #ddd;
    border-left: none;
    border-right: none;
    padding: 0.3rem;
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    text-align: center;
    max-width: 15rem;
}

.note-grid th {
    background-color: #f2f2f2;
}

.note-grid tr:nth-child(even) {
    background-color: #f9f9f9;
}

.note-grid th:hover {
    cursor: default;
}

.note-grid tr:hover {
    background-color: #f5f5f5;
    cursor: pointer;
}
</style>
